import axios from 'axios';
import { refreshAccessToken } from "services/AuthService";
import { AuthApi } from "./index";

const customerAxiosInstance = ({ apiUrl, brand, env, customerData, customHeaders = {} }) => {
  const { accessToken, refreshToken, apiAccessToken } = customerData;
  const authApi = AuthApi(apiUrl, apiAccessToken);

  const instance = axios.create({
    baseURL: apiUrl,
    headers: {
      'X-Brand-Id': brand,
      'X-Customer-Token': accessToken,
      'X-Access-Token': apiAccessToken,
      ...customHeaders,
    }
  });

  instance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        originalRequest.headers['X-Customer-Token'] = await refreshAccessToken(authApi, brand, env, refreshToken);
        return instance(originalRequest);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default customerAxiosInstance;
